import { CombinedSweep, MatterSweep, NavigationSweep } from '@/components/util/sdk/sweep/types';

export const getAllSweeps = (matterSweeps: MatterSweep[], treedisSweeps: NavigationSweep[]): Map<string, CombinedSweep> => {
  const allSweeps = new Map();

  matterSweeps.forEach((s) => {
    //@ts-ignore
    const index = treedisSweeps.findLastIndex(
      (item: NavigationSweep) => s.id === item?.sweepId || s.id === item?.sweep_uuid || s.sweep_uuid === item?.sweep_uuid || s.sweep_uuid === item?.sweepId,
    );
    const found = index === -1 ? null : treedisSweeps[index];

    const sweep = {
      id: found ? found.sweepId : s.id,
      enabled: found ? found.enabled : s.tags.includes('showcase'),
      isCustom: found?.isCustom ? found?.isCustom : false,
      name: found?.name || `Sweep ${+s.label + 1}`,
      index: found ? (found.isCustom ? null : +found.name.split(' ')[1] - 1) : +s.label,
      tourId: found ? found.tourId : null,
      positionX: found?.positionX ? found.positionX : s?.position?.x,
      positionY: found?.positionY ? found.positionY : s?.position?.y,
      positionZ: found?.positionZ ? found.positionZ : s?.position?.z,
      neighbourSweeps: found?.neighbourSweeps || s.neighbors,
      floor: found && found.floor !== null ? found.floor : s.floor?.sequence,
      sweepId: found ? found.sweepId : s.id,
      sweep_uuid: found ? found.sweep_uuid : s.sweep_uuid,
      treedisId: found ? found.id : null,
      createdAt: found ? found.createdAt : null,
      updatedAt: found ? found.updatedAt : null,
      title: found ? found.title : null,
      isMandatory: found ? found.isMandatory : false,
    };

    allSweeps.set(sweep.id, { ...sweep, modifiedSweep: !!found });
  });

  treedisSweeps.forEach((s) => {
    if (s.isCustom) {
      allSweeps.set(`treedis_${s.id}`, {
        ...s,
        id: `${s.id}`.startsWith('treedis_') ? `${s.id}` : `treedis_${s.id}`,
        treedisId: s.id,
        index: null,
        modifiedSweep: true,
      });
    }
  });
  return allSweeps;
};
